<template lang="pug">
v-container.fill-height.container.pa-0(fluid)
    v-row.ma-0.text-h1.bolt.mb-6(no-gutters justify="center")
      v-col(cols="12" v-if="!fetchInProgress" align="center") {{ $t('loginPage.cardTitle') }}
      v-col(cols="12" v-else align="center")  {{ $t('loginPage.fetchCardData') }}
        v-progress-circular.ml-4(indeterminate color="black")
      v-col.pt-10.mt-10(cols="12")
        v-row.ma-0.alert-Style(no-gutters justify="center" )
          v-col(cols="6")
            v-alert.align-center.style.text-h4( type="error" icon="fal fa-exclamation-circle" v-show="isInvalidCredentials")
              v-row.ma-0.align-center()
                v-col {{ $t('loginPage.invalidCredentials') }}
                v-col.shrink.pa-0
                  v-btn.text-end(right fab icon @click="isInvalidCredentials = false")
                    v-icon fal fa-times-circle
    v-row.ma-0.guiding-image(no-gutters)
      v-col.align-center
        v-img.guiding-image( :src="require('@/assets/hand_with_card.jpg')" contain)


</template>

<script lang="ts">
import Vue from 'vue'
import {Component} from 'vue-property-decorator'
import {AUTH_LOG_USER_IN} from "@/store/action-types";
import {UserCredentialsPayload} from "@/types/payload";
import InvalidCredentialsError from "@/model/error/InvalidCredentialsError";
import {GET_CID, GET_MODE, GET_TT} from "@/store/getter-types";

@Component({})
export default class LoginPageKiosk extends Vue {

  private userId: string = ''
  private username: string | null = null
  private partialUserId: string = ''
  private fetchInProgress: boolean = false
  private isInvalidCredentials: boolean = false
  private timeOutAlert: ReturnType<typeof setTimeout>  | null = null
  private eventKeyTimeOut: ReturnType<typeof setTimeout>  | null = null


  get isKioskMode (): boolean {
    return this.$store.getters[GET_MODE] === 'kiosk'
  }

  performLogin(event: KeyboardEvent) {
    if(!this.fetchInProgress) {
      if (event.key !== "Enter") {
        if(this.eventKeyTimeOut) {
          clearTimeout(this.eventKeyTimeOut)
        }
        this.eventKeyTimeOut = setTimeout( () => {
          this.partialUserId = ''
        }, 1000);
        if(event.key.length === 1 && event.code !== 'Space') {
          this.partialUserId += event.key
        }
      } else {
        if(this.eventKeyTimeOut) {
          clearTimeout(this.eventKeyTimeOut)
        }
        if(this.partialUserId.length > 0) {
          this.onLogUser(this.partialUserId)
          this.partialUserId = ''
          this.isInvalidCredentials = false
          if(this.timeOutAlert) {
            clearTimeout(this.timeOutAlert)
          }
        }
      }
    }
  }

  onLogUser(item: string): void {
    if(item.includes('lunchmenu.today')){
      this.userId = item.slice(-36)
    } else {
      this.userId = item
    }

    const payload: UserCredentialsPayload = {
        username: this.userId,
        password: 'qr'
      }
      this.fetchInProgress = true

      this.$store.dispatch(AUTH_LOG_USER_IN, payload)
          .catch((e: InvalidCredentialsError) => {
            window.addEventListener('keyup',this.performLogin)
            this.isInvalidCredentials = true
            this.timeOutAlert = setTimeout(() => {
              this.isInvalidCredentials = false
            }, 5000)
            this.fetchInProgress = false
          })
  }

  mounted() {
    localStorage.removeItem('token')

    const urlParams: URLSearchParams = new URLSearchParams(window.location.search)
    let t: string | null = urlParams.get('t')
    let cid: string | null = this.$store.getters[GET_CID]
    let tt: string | null = this.$store.getters[GET_TT]

    if(t && cid && tt) {
      t = t.replace(' ', '+')
      this.onLogUser(`${cid}:${tt}:${t}`)
    } else {
      window.addEventListener('keyup',this.performLogin)
    }
  }

  destroyed(){
    window.removeEventListener('keyup',this.performLogin)
    if(this.timeOutAlert) {
      clearTimeout(this.timeOutAlert)
    }
    if(this.eventKeyTimeOut) {
      clearTimeout(this.eventKeyTimeOut)
    }
  }
}
</script>

<style lang="stylus" scoped>
.alert-Style {
  height 100px
}

.style {
  >>> .v-alert__icon{
    padding-top 33px
  }
}
.container
  max-height: calc(100vh - 96px)
  height: calc(100vh - 96px)

.guiding-image
  //position fixed
  //bottom 40px
  //left 120px
  height 200px

</style>
